var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTraderEvolution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 318.7 71.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3f87f4;}.cls-2{fill:#fefefe;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.92,33.85c-.92,0-1.83-.17-2.7-.53v25.32c0,4-3.25,7.24-7.24,7.24H12.76c-4,0-7.24-3.25-7.24-7.24V15.42c0-3.99,3.25-7.24,7.24-7.24h25.36c-.32-.82-.5-1.71-.5-2.62,0-1.01,.21-1.99,.61-2.89H12.76C5.72,2.67,0,8.39,0,15.42V58.64c0,7.04,5.72,12.76,12.76,12.76H55.98c7.03,0,12.76-5.72,12.76-12.76v-25.37c-.89,.38-1.86,.58-2.82,.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.69,11.85c1.36,1.36,1.36,3.57,0,4.93-1.36,1.37-3.57,1.37-4.93,0-1.36-1.36-1.36-3.57,0-4.93,1.36-1.36,3.57-1.36,4.93,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.14,1.79c2.38,2.39,2.38,6.25,0,8.64-2.39,2.39-6.26,2.39-8.64,0-2.38-2.38-2.38-6.25,0-8.64,2.38-2.39,6.25-2.39,8.64,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.49,11.92c2.04,2.05,2.04,5.36,0,7.41-2.04,2.04-5.36,2.04-7.4,0-2.04-2.05-2.04-5.36,0-7.41,2.04-2.04,5.36-2.04,7.4,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.77,23.71c1.71,1.71,1.71,4.47,0,6.17-1.7,1.71-4.47,1.71-6.17,0-1.7-1.7-1.7-4.47,0-6.17,1.71-1.7,4.47-1.7,6.17,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.89,34.74c1.36,1.36,1.36,3.58,0,4.94-1.36,1.36-3.57,1.36-4.94,0-1.36-1.36-1.36-3.57,0-4.94,1.36-1.36,3.58-1.36,4.94,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.89,43.49c.82,.82,.82,2.14,0,2.96-.82,.82-2.14,.82-2.96,0-.82-.82-.82-2.14,0-2.96,.82-.82,2.14-.82,2.96,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.72,1.81c1.79,1.8,1.79,4.71,0,6.5-1.8,1.8-4.71,1.8-6.5,0-1.79-1.79-1.79-4.71,0-6.5C45.01,.02,47.92,.02,49.72,1.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.52,22.2c1.8,1.79,1.79,4.71,0,6.5-1.8,1.8-4.71,1.8-6.5,0-1.79-1.79-1.79-4.7,0-6.5,1.8-1.79,4.71-1.79,6.5,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.64,31.07c1.36,1.36,1.36,3.57,0,4.93-1.36,1.36-3.57,1.36-4.93,0-1.36-1.36-1.36-3.57,0-4.93,1.36-1.36,3.57-1.36,4.93,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.17,38.85c1.13,1.13,1.13,2.98,0,4.11-1.14,1.14-2.98,1.14-4.11,0-1.14-1.13-1.14-2.98,0-4.11,1.13-1.13,2.97-1.13,4.11,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.51,45.86c.72,.73,.72,1.9,0,2.63-.73,.73-1.91,.73-2.63,0-.73-.73-.73-1.9,0-2.63,.73-.73,1.91-.73,2.63,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.21,19.63c1.14,1.13,1.14,2.97,0,4.11-1.13,1.14-2.97,1.14-4.11,0-1.13-1.13-1.13-2.98,0-4.11,1.13-1.13,2.97-1.13,4.11,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.56,26.64c.73,.73,.73,1.9,0,2.63-.73,.73-1.91,.73-2.63,0-.73-.73-.73-1.9,0-2.63,.72-.73,1.91-.73,2.63,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.93,50.45c.46,.46,.46,1.2,0,1.66-.46,.46-1.2,.46-1.66,0-.46-.46-.46-1.2,0-1.66,.46-.46,1.2-.46,1.66,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.63,52.74c.41,.41,.41,1.08,0,1.49-.41,.42-1.08,.42-1.49,0-.41-.41-.41-1.08,0-1.49,.41-.42,1.08-.42,1.49,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.67,33.53c.41,.41,.41,1.07,0,1.47-.41,.41-1.07,.41-1.47,0-.41-.41-.41-1.07,0-1.47,.41-.41,1.07-.41,1.47,0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "92.19 30.2 92.19 13.63 83.74 13.63 83.74 8.44 106.51 8.44 106.51 13.63 98.04 13.63 98.04 30.2 92.19 30.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.24,30.2h0l-4.55-7.16c-2.31,0-4.34,0-6.5,.01v7.15h-5.84V8.44c4.09-.02,8.1-.02,12.03-.02h.91c7.27,0,9.29,2.58,9.29,6.51v1.3c0,2.72-.91,5.1-3.71,6.3l4.88,7.66h-.85s-5.66,0-5.66,0h0Zm-11.05-16.93v4.61c2.02-.02,4.14-.02,5.24-.02,5.2,0,5.28-1.56,5.28-2.21,0-.51,.02-2.4-4.23-2.4-1.5,0-3.9,0-6.29,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M243.49,30.2h0l-4.54-7.16c-2.3,0-4.48,0-6.52,.01v7.15h-5.85V8.44c4.01-.02,8.23-.02,12.16-.02h.91c7.28,0,9.16,2.58,9.16,6.51v1.3c0,2.72-.91,5.1-3.7,6.3l4.86,7.66h-.83s-5.65,0-5.65,0Zm-11.05-16.93v4.61c2.08-.02,4.16-.02,5.26-.02,5.2,0,5.37-1.49,5.4-2.32,.03-.75-.16-2.28-4.42-2.28-1.49,0-4,0-6.24,.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141,30.2h-.54s9.38-21.76,9.38-21.76h5.01l9.41,21.76h-5.83l-1.89-4.23h-8.57l-1.71,4.23h-5.26Zm14.1-9.1l-2.75-7.44-2.76,7.44h5.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.08,20.16h0c0,5.88-2.79,10.04-12.73,10.04h-1.17c-3.31,0-5.58,0-8.7,0V8.47c3.43-.03,5.39-.05,8.7-.05h1.17c9.94,0,12.73,4.18,12.73,10.06v1.69h0Zm-5.98-.85c0-3.7,0-6.37-7.76-6.37-1.14,0-1.55,.03-3.02,.13v12.51c1.46,.09,1.88,.13,3.02,.13,7.76,0,7.76-2.7,7.76-6.4h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "220.59 13.63 203.93 13.63 203.93 16.88 217.34 16.88 217.34 22.08 203.93 22.08 203.93 25 220.59 25 220.59 30.2 198.09 30.2 198.09 8.44 220.59 8.44 220.59 13.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "106.73 49.71 89.94 49.71 89.94 52.96 103.48 52.96 103.48 58.16 89.94 58.16 89.94 61.08 106.73 61.08 106.73 66.28 84.09 66.28 84.09 44.52 106.73 44.52 106.73 49.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "135.37 44.52 135.91 44.51 126.95 66.28 121.1 66.28 112.14 44.51 112.68 44.52 117.94 44.52 124.02 61.08 130.11 44.52 135.37 44.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M140.86,54.55h0c0-5.88,1.51-10.68,10.96-10.68h1.03c9.45,0,10.96,4.81,10.96,10.68v1.69c0,5.88-1.51,10.69-10.96,10.69h-1.03c-9.45,0-10.96-4.81-10.96-10.69v-1.69Zm11.41,7.18c6.82,0,6.54-3.02,6.54-6.33s.28-6.3-6.54-6.3-6.54,3.02-6.54,6.3-.28,6.33,6.54,6.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.31,54.55h0c0-5.88,1.51-10.68,10.96-10.68h1.03c9.45,0,10.96,4.81,10.96,10.68v1.69c0,5.88-1.51,10.69-10.96,10.69h-1.03c-9.45,0-10.96-4.81-10.96-10.69v-1.69Zm11.41,7.18c6.82,0,6.54-3.02,6.54-6.33s.28-6.3-6.54-6.3-6.54,3.02-6.54,6.3-.28,6.33,6.54,6.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "169.91 66.28 169.91 44.52 175.75 44.52 175.75 61.08 192.41 61.08 192.41 66.28 169.91 66.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M221.13,44.52v12.7c0,5.32-2.43,9.71-11.09,9.71h-.47c-8.66,0-11.09-4.38-11.09-9.71v-12.7h5.84v11.86c0,2.83-.28,5.36,5.56,5.36s5.41-2.53,5.41-5.36v-11.86h5.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "235.35 66.28 235.35 49.71 227.05 49.71 227.05 44.52 249.54 44.52 249.54 49.71 241.2 49.71 241.2 66.28 235.35 66.28"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 255.64,
    y: 44.52,
    width: 5.85,
    height: 21.76
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "312.85 58.48 312.85 44.52 318.7 44.52 318.7 66.28 312.85 66.28 302.01 52.31 302.01 66.28 296.17 66.28 296.17 44.52 302.01 44.52 312.85 58.48"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTraderEvolution);
export default __webpack_public_path__ + "static/media/LogoTraderEvolution.a90c65544dfac229b7ab579ab0368758.svg";
export { ForwardRef as ReactComponent };